module.exports = __webpack_public_path__ + "img/casino-skywind.9db9a940.jpg";